import { ProfileActions, ProfileActionTypes } from '../../actions/account/actions-profile';
import { ProfileState } from '../../models/account/profile.state';

export const profileInitState: ProfileState = {
  isLoading: true,
  entity_id: -1,
  firstname: '',
  lastname: '',
  firstname_local: '',
  lastname_local: '',
  contactEmail: '',
  primary_business_option: { value: -1, values: [{ value: -1, label: '' }] },
  nameTitleOption: '',
  job_position: { value: -1, values: [{ value: -1, label: '' }] },
  job_area: { value: -1, values: [{ value: -1, label: '' }] },
  timezone: { value: -1, values: [{ value: -1, label: '' }] },
  preferred_language: '',
  portal_language: '',
  workPhoneNumber: '',
  mobilePhoneNumber: '',
  address: {
    street: '',
    city: '',
    officeId: '',
    postalCode: '',
    province: '',
    country: ''
  }
};

/* eslint-disable */
export function reducersProfile(state = profileInitState, action: ProfileActions): ProfileState {
  switch (action.type) {
    case ProfileActionTypes.GetProfile:
      return { ...state, isLoading: true };

    case ProfileActionTypes.GetProfileSuccess:
      return { ...action.payload, isLoading: false };

    case ProfileActionTypes.UpdateProfileInit:
      return { ...state, isLoading: true };

    case ProfileActionTypes.UpdateProfileSuccess:
      return { ...state, isLoading: true };

    default:
      return state;
  }
}
